
  import createMeisterIcons from '../src/createMeisterIcons';

  const Union = createMeisterIcons("union", [["path",{"fill":"currentColor","d":"M3.3 12a5.15 5.15 0 0 1 7.454-4.607A6.63 6.63 0 0 0 8.9 12a6.63 6.63 0 0 0 1.854 4.607A5.15 5.15 0 0 1 3.3 12m8.7 5.624a6.65 6.65 0 1 1 0-11.248 6.65 6.65 0 1 1 0 11.248m1.246-10.231a5.15 5.15 0 1 1 0 9.214A6.63 6.63 0 0 0 15.1 12a6.63 6.63 0 0 0-1.854-4.607M12 8.269A5.14 5.14 0 0 1 13.6 12a5.14 5.14 0 0 1-1.6 3.731A5.14 5.14 0 0 1 10.4 12c0-1.468.614-2.793 1.6-3.731","key":"62df7e4407a05519960d4bf21ede6a16cc4357cb","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Union
  